<template>
  <v-layout row wrap>
    <slot></slot>
    <v-flex xs12 sm12>
      <component
        v-bind:is="inputType"
        :loading="loading"
        :items="items"
        :filter="customFilter()"
        :item-text="field"
        item-value="id"
        :label="$t(label)"
        :search-input.sync="searchInput"
        :no-data-text="$t('noDataText')"
        @change="change"
        :append-icon="saveable ? 'save' : ''"
        @click="refresh()"
        @click:append="saveSearchValue"
        :value="selectedValue"
        :error-messages="validation ? $errors(validation) : []"
        :readonly="readonly"
        :disabled="disabled"
        :defaultValue="defaultValue"
        @blur="checkIfValueChanged"
        :prepend-icon="prependIcon"
        :clearable="clearable"
        @click:clear="clear"
        @focus="
          refresh()
          visible = true
        "
      />
    </v-flex>
    <v-dialog v-model="confirmDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('confirm.add') }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn flat="flat" @click="confirmDialog = false">
            {{ $t('button.cancel') }}
          </v-btn>

          <v-btn flat="flat" @click="addElement">
            {{ $t('button.create') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import toasted from '@/utils/toasted'

export default {
  beforeMount() {
    if (this.eagerLoading) {
      this.refresh()
    }
  },
  props: {
    datasource: Object,
    field: String,
    additionalField: Array,
    label: String,
    search: String,
    selected: Number,
    saveable: {
      type: Boolean,
      default: false,
    },
    value: Object,
    validation: Object,
    serverSearch: Boolean, // active ou non la recherche serveur
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: Object,
      default: null,
    },
    eagerLoading: {
      type: Boolean,
      default: false,
    },
    prependIcon: {
      type: String,
    },
    doUpdateItems: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],
      loading: false,
      searchInput: null,
      confirmDialog: false,
      selectedValue: this.value,
      changed: false,
      saving: false,
      loaded: false,
    }
  },
  computed: {
    inputType() {
      return 'v-combobox'
      //return this.saveable ? 'v-combobox' : 'v-autocomplete';
    },
  },
  mounted() {
    this.$nextTick(function () {
      if (this.defaultValue != null && !this.disabled && !this.value) {
        this.selectedValue = Object.assign({}, this.defaultValue)
      }
    })
  },
  watch: {
    searchInput(value) {
      if (this.isLoading) return
      if (this.changed) return
      if (this.serverSearch) return
      this.updateList(value)
    },
    value(val) {
      this.selectedValue = val
    },
    doUpdateItems(val) {
      // on force la mise à jour des éléments
      if (val) {
        this.refreshDatasource()
      }
    },
  },
  methods: {
    updateList(value) {
      if (value !== null && this.serverSearch) {
        this.loading = true
        //this.datasource.args[this.search] = value;
        this.$emit(this.datasource.args[this.search], value)
        this.refreshDatasource()
      }
    },
    refreshDatasource() {
      this.datasource
        .refresh()
        .then(() => {
          this.updateItems()
        })
        .finally(() => {
          this.loading = false
          this.$emit('updated')
        })
    },
    customFilter() {
      return this.serverSearch ? () => true : undefined
    },
    updateItems() {
      this.items = this.datasource.items.map((elt) => {
        let result = {}
        result[this.field] = elt[this.field]
        if (this.additionalField) {
          this.additionalField.map((x) => (result[x] = elt[x]))
        }
        result.id = elt.id
        return result
      })
    },

    change(event) {
      this.changed = true
      if (event !== null && event !== undefined && event !== '' && event.id) {
        // l'évènement doit avoir un id, sinon on tente de le sauvegarder
        this.$emit('input', event)
        this.$emit('change', event)
      }

      if (event === '') {
        this.$emit('cleared')
      }
    },
    clear() {
      this.$emit('cleared')
    },
    addElement() {
      this.$api(this.datasource.namespace)
        .put({ label: this.searchInput })
        .then(
          (response) => {
            toasted.info('succes')
            this.confirmDialog = false
            this.items.push(response.body)
            this.$emit('input', response.body)
          },
          () => toasted.error('error'),
        )
        .finally(() => {
          this.updateList('')
        })
    },
    checkIfValueChanged() {
      if (
        this.selectedValue &&
        this.selectedValue[this.field] !== this.searchInput &&
        !this.saving
      ) {
        this.searchInput = this.selectedValue[this.field]
      }
    },
    saveSearchValue() {
      if (this.searchInput && this.searchInput != '') {
        this.saving = true
        this.confirmDialog = true
      }
    },
    refresh() {
      if (!this.loaded) {
        this.datasource.refresh().then(() => this.updateItems())
        this.loaded = true
      }
    },
  },
}
</script>
